import { render } from "./RedesSociais.vue?vue&type=template&id=ef19e1aa&scoped=true"
import script from "./RedesSociais.vue?vue&type=script&lang=js"
export * from "./RedesSociais.vue?vue&type=script&lang=js"

import "./RedesSociais.vue?vue&type=style&index=0&id=ef19e1aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef19e1aa"]])

export default __exports__